import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import './assets/fonts/fonts';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import './locales';
import ReactGA from 'react-ga';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
if (process.env.NODE_ENV === 'production') {
  ReactGA.initialize('1c9985a833491e0');
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

// serviceWorkerRegistration.register();
// serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
